<template>
  <div class="w-auto relative">
    <div class="relative flex w-[115px] h-[115px] md:min-w-[180px] md:min-h-[180px] max-w-[425px] max-h-[425px]"
    :class = "{
      'w-[180px] h-[180px]' : isPDFPrinting
    }">    
      <Doughnut :id="id" :options="chartOptions" :data="chartData" />
      
      <div 
        class="absolute z-0 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center flex flex-col items-center"
      >
        <p 
          v-if="caption.p1 !== ''" 
          class="!text-[8px] md:!text-[14px] 4xl:!text-[18px] 5xl:!text-[28px] text-gray-400 text-center font-inter text-base font-normal leading-normal m-0"
          :class = "{
            '!text-[14px]' : isPDFPrinting
          }"
          >
          {{ caption.p1 }}
        </p>
        
        <p 
          v-if="caption.p2 !== ''" 
          class="!text-[8px] md:!text-[14px] 4xl:!text-[18px] 5xl:!text-[28px] text-gray-400 text-center font-inter text-base font-normal leading-normal m-0"
          :class = "{
            '!text-[14px]' : isPDFPrinting
          }"
          >
          {{ caption.p2 }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { DOUGHNUT_COLORS } from "@/constants";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "vue-chartjs";

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
  props: {
    id: {
      default: "my-chart-id",
      type: String,
    },
    labels: {
      default: () => [],
      type: Array,
    },
    data: {
      default: () => [],
      type: Array,
    },
    rotation: {
      default: -90,
      type: Number,
    },
    // Updated prop definition for better Vue 3 compatibility and clarity
    caption: {
      type: Object,
      default: () => ({
        p1: "",
        p2: "",
        h1: "",
      }),
    },
    isPDFPrinting: {
        type: Boolean,
        default: false,
    }
  },
  components: { Doughnut },
  computed: {
    chartData() {
      // Logic for handling all-zero data remains the same
      return {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: DOUGHNUT_COLORS,
            borderColor: this.data.every((num) => num === 0)
              ? "#D9D9D9"
              : "#fff",
            data: this.data.every((num) => num === 0)
              ? [0, 0, 0, 1] // Placeholder for empty state
              : this.data,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "85%",
        rotation: this.rotation,
        legend: {
          display: false,
        },
        animation: {
          animateRotate: true,
          animateScale: false,
        },
        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
          },
        },
      };
    },
  },
};
</script>